
const CaseStudiesSection = () => {
  const caseStudies = [
    {
      industry: '医療業界',
      company: 'A医療法人',
      challenge: '月末の勤怠集計作業に丸2日かかっていた',
      solution: 'Google Apps Scriptで勤怠データを自動集計・レポート生成',
      result: '作業時間を90%削減（2日→2時間）',
      icon: 'ri-hospital-line',
      color: 'blue',
      image: 'https://public.readdy.ai/ai/img_res/69b4c87d3f25aa10a5d87844849994a8.jpg'
    },
    {
      industry: '清掃業界',
      company: 'B清掃サービス',
      challenge: '予約管理が属人化し、ダブルブッキングが頻発',
      solution: 'LINE Bot + スプレッドシート連携で予約データを自動反映',
      result: '属人化を解消、ダブルブッキング0件達成',
      icon: 'ri-broom-line',
      color: 'green',
      image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20service%20team%20using%20digital%20scheduling%20and%20booking%20systems%2C%20modern%20office%20environment%20with%20automated%20workflow%20management%2C%20clean%20corporate%20setting%20with%20green%20and%20white%20design&width=400&height=300&seq=case2&orientation=landscape'
    },
    {
      industry: '教育業界',
      company: 'C学習塾',
      challenge: '月謝請求書の作成に毎月10時間以上かかっていた',
      solution: 'Googleフォーム + GASで請求書を自動生成・メール送信',
      result: '請求書作成時間を95%削減（10時間→30分）',
      icon: 'ri-book-open-line',
      color: 'purple',
      image: 'https://readdy.ai/api/search-image?query=Educational%20institution%20with%20teachers%20and%20staff%20using%20automated%20administrative%20systems%2C%20modern%20classroom%20and%20office%20environment%20with%20digital%20tools%2C%20clean%20academic%20setting%20with%20purple%20and%20white%20color%20scheme&width=400&height=300&seq=case3&orientation=landscape'
    }
  ];

  const testimonials = [
    {
      name: '田中様',
      company: '製造業・経営者',
      comment: '導入前は手作業で5時間かかっていた在庫管理が、今では30分で完了します。スタッフも他の重要な業務に集中できるようになりました。',
      rating: 5
    },
    {
      name: '佐藤様',
      company: 'サービス業・店長',
      comment: 'LINE Botでの予約受付システムが大好評です。24時間受付可能になり、売上も20%アップしました。',
      rating: 5
    },
    {
      name: '山田様',
      company: 'IT企業・マネージャー',
      comment: '複雑な業務フローも丁寧にヒアリングしてくれて、想像以上の自動化を実現してくれました。ROIも3ヶ月で回収できました。',
      rating: 5
    }
  ];

  return (
    <section id="case-studies" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            導入<span className="text-blue-600">事例</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            様々な業界・業種での自動化事例をご紹介します
          </p>
        </div>

        {/* 導入事例 */}
        <div className="grid lg:grid-cols-3 gap-8 mb-20">
          {caseStudies.map((study, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow">
              <div className="mb-6">
                <img 
                  src={study.image}
                  alt={`${study.industry}の導入事例`}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <div className={`w-16 h-16 bg-${study.color}-100 rounded-full flex items-center justify-center mx-auto`}>
                  <i className={`${study.icon} text-2xl text-${study.color}-600`}></i>
                </div>
              </div>
              
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {study.industry}
                </h3>
                <p className="text-sm text-gray-500 mb-4">{study.company}</p>
                
                <div className="space-y-4 text-left">
                  <div>
                    <h4 className="font-semibold text-red-600 mb-2">課題</h4>
                    <p className="text-gray-600 text-sm">{study.challenge}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-blue-600 mb-2">解決策</h4>
                    <p className="text-gray-600 text-sm">{study.solution}</p>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold text-green-600 mb-2">効果</h4>
                    <p className="text-gray-900 text-sm font-semibold">{study.result}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* お客様の声 */}
        <div className="bg-gray-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            お客様の声
          </h3>
          
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-md">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400"></i>
                  ))}
                </div>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  "{testimonial.comment}"
                </p>
                <div className="border-t pt-4">
                  <p className="font-semibold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.company}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 成果指標 */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 text-white">
          <h3 className="text-2xl font-bold mb-8 text-center">
            数字で見るAutocroveの成果
          </h3>
          
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">90%</div>
              <div className="text-blue-100">平均工数削減率</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">3ヶ月</div>
              <div className="text-blue-100">平均ROI回収期間</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">95%</div>
              <div className="text-blue-100">お客様継続率</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">50+</div>
              <div className="text-blue-100">導入実績数</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
